import { compose, gte, __, length, filter, propEq } from 'ramda';

export const isDisabledAddingBeneficiary = (nbMax, type) =>
  compose(gte(__, nbMax), length, filter(propEq('type', type)));
